import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from '../../components/ui/card';

export interface FunnelData {
  clicks: number;
  registrations: number;
  deposits: number;
}

interface ConversionFunnelProps {
  data: FunnelData;
}

const ConversionFunnel = ({ data }: ConversionFunnelProps) => {
  return (
    <Card>
      <CardHeader>
        <CardTitle>Conversion Funnel</CardTitle>
        <CardDescription>
          Track conversion from clicks to deposits
        </CardDescription>
      </CardHeader>
      <CardContent>
        <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
          <div className="p-6 border rounded-lg">
            <div className="text-sm text-muted-foreground mb-2">Clicks</div>
            <div className="text-3xl font-bold">{data.clicks}</div>
          </div>
          <div className="p-6 border rounded-lg">
            <div className="text-sm text-muted-foreground mb-2">
              Registrations
            </div>
            <div className="text-3xl font-bold">{data.registrations}</div>
          </div>
          <div className="p-6 border rounded-lg">
            <div className="text-sm text-muted-foreground mb-2">Deposits</div>
            <div className="text-3xl font-bold">{data.deposits}</div>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

export default ConversionFunnel;
